import withZendesk from '../../../components/HOCs/withZendesk';
import AccentBox from '../../../components/molecules/accentBox/AccentBox';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';

const AccentBoxTastic = (props) => {
  const { data, openChat, context } = props;
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <AccentBox
      background={data.background}
      title={data.title}
      description={data.description}
      phoneNumber={data.phoneNumber}
      phoneIcon={data.phoneIcon.media}
      address={data.address}
      adressIcon={data.adressIcon.media}
      liveChatEnabled={data.liveChatEnabled}
      liveChatIcon={data?.liveChatIcon?.media}
      text={data.text}
      placement={data.placement}
      onOpenChat={openChat}
    />
  );
};

AccentBoxTastic.propTypes = {
  data: PropTypes.object.isRequired,
};

export default compose(
  withZendesk,
  tastify({
    translate: true,
    connect: { context: true },
  }),
)(AccentBoxTastic);
